import styled from 'styled-components';

import { Text, Title } from '@/components/ErrorPage/MainSection/Finance/style';
import {
  colorSurfaceButton,
  colorSurfaceTextPrimary,
  colorSurfaceTextSecondary,
  colorWhite,
  fontFamilyMulti,
  mediaQueryTabletSmallMin,
} from '@/styleUtils';

export const FullHeightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${mediaQueryTabletSmallMin} {
    position: relative;
    margin-top: 40px;
    top: auto;
    left: auto;
    transform: none;
  }
`;
export const ButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
export const Button = styled.a`
  display: flex;
  text-decoration: none;
  border-radius: 62px;
  gap: 8px;
  width: max-content;
  height: 56px;
  align-items: center;
  padding: 16px;
  background-color: ${({ $color }) => $color || colorSurfaceButton};
  font: normal 16px / 20px ${fontFamilyMulti};
  color: ${colorWhite};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
export const StyledText = styled(Text)`
  font: 400 18px / 24px ${fontFamilyMulti};
  letter-spacing: 0.18px;
  color: ${colorSurfaceTextSecondary};
  margin-top: 16px;
  margin-bottom: 56px;
`;
export const StyledTitle = styled(Title)`
  font: 700 24px / 28px ${fontFamilyMulti};
  color: ${colorSurfaceTextPrimary};
  letter-spacing: 0.24px;
  margin-top: 24px;
`;
